import * as React from 'react';
import { Accordion } from 'damco-components';
import PropertyDisplay from 'components/cost-revenue/PropertyDisplay';
import Table from 'components/data-table/Table';
import { IProps } from '../../utils/models';
import { formatData, sortElementByKey } from 'utilities/util';
import { redirectToViewInvoice } from 'utilities/route-utils';

class DocumentDetails extends React.Component<IProps> {
    public createLink = (data: any) => {
        this.props.link(String(`/job-costing/booking/${data!.id}`))
    }
    public render() {
        const newEquipmentTransport = this.props.equipmentTransportShipments;
        newEquipmentTransport.data = newEquipmentTransport.data.filter(equipment => !equipment.isCancelled)
        if (newEquipmentTransport.data && newEquipmentTransport.data.length) {
            newEquipmentTransport.data = newEquipmentTransport.data.map((data: any) => {
                if (data.anyIssoSent) {
                    data.anyIssoSent = data.anyIssoSent.toString()
                }
                return data
            })
        }

        const extraDocsETS = JSON.parse(JSON.stringify(newEquipmentTransport));
        if (extraDocsETS.data && extraDocsETS.data.length) {
            extraDocsETS.data = extraDocsETS.data.filter((val: any) => val.equipmentTransportShipmentDocumentNumber && (val.equipmentTransportShipmentDocumentNumber.startsWith('IED')));
        }
        const exceptExtraDocsETS = JSON.parse(JSON.stringify(newEquipmentTransport));
        if (exceptExtraDocsETS.data && exceptExtraDocsETS.data.length) {
            exceptExtraDocsETS.data = exceptExtraDocsETS.data.filter((val: any) => val.equipmentTransportShipmentDocumentNumber && !val.equipmentTransportShipmentDocumentNumber.startsWith('IED'));
        }
        const customerData = this.props.customerInvoice;
        customerData.data = customerData.data.map((data: any) => {
            const newData = formatData([data])
            return newData[0]
        })
        customerData.data = sortElementByKey(customerData.data, 'createdDate', true, 'date');

        const newCLR = { ...this.props.clr };
        if (newCLR && newCLR.data) {
            newCLR.data = newCLR.data.map((data: any) => {
                const clr = formatData([data])
                return clr[0]
            })
        }
        return (
            <div className="padding-top-large padding-bottom-large">
                <Accordion title={'Organisation'} id="organisation">
                    <PropertyDisplay data={[...this.props.organisation]} id="organisation" />
                </Accordion>
                <Accordion title={'Locations'} id="locations">
                    <PropertyDisplay data={[...this.props.locations]} id="locations" />
                </Accordion>
                <Accordion title={'Cargo details'} id="cargoDetails">
                    <PropertyDisplay data={[...this.props.cargoDetails]} id="cargoDetails" />
                </Accordion>
                <Accordion title={'Job Id details'} id="jobIdDetailsCollapse">
                    <PropertyDisplay data={[...this.props.jobIdDetails]} id="jobIdDetails" />
                </Accordion>
                <Accordion title={'Booking'} id="booking">
                    <Table
                        {...this.props.bookings}
                        id="FCR-details-bookings"
                        hasTotal={true}
                        linkAction={(row: any) => { this.createLink(row) }} />
                </Accordion>
                <Accordion title={'clr'}>
                    <Table {...newCLR}
                        id="equipments-details-clr"
                        hasTotal={true}
                    />
                </Accordion>
                <Accordion title={'cbl'} id="cbl">
                    <Table {...this.props.cbl}
                        id="FCR-details-cbl"
                        hasTotal={true}
                        linkAction={(row: any) => this.props.link(String(`/job-costing/cbls/${row!.id}`))} />
                </Accordion>
                <Accordion title={'equipment'} id="equipment">
                    <Table {...this.props.equipments} id="FCR-details-equipment"
                        hasTotal={true}
                        linkAction={(row: any) => this.props.link(String(`/job-costing/equipments/${row!.equipmentId}`))} />
                </Accordion>
                {!this.props.isExtraDocumentFeatureEnabled && <Accordion title={'EQUIPMENT TRANSPORT SHIPMENTS'} id="eqTransportShipments">
                    <Table {...newEquipmentTransport} hasTotal={true}
                        id="FCR-details-equipmentTransportShipments"
                        linkAction={(row: any) => this.props.link(String(`/job-costing/ets/${row!.id}`))} />
                </Accordion>
                }
                {this.props.isExtraDocumentFeatureEnabled &&
                    <Accordion title={'EQUIPMENT TRANSPORT SHIPMENTS'} id="eqTransportShipments">
                        <Table {...exceptExtraDocsETS} id="FCR-details-equipmentTransportShipments"
                            hasTotal={true}
                            linkAction={(row: any) => this.props.link(String(`/job-costing/ets/${row!.id}`))} />
                    </Accordion>
                }
                {this.props.isExtraDocumentFeatureEnabled &&
                    extraDocsETS.data &&
                    extraDocsETS.data.length > 0 &&
                    <Accordion title={'Import Extra Document'}>
                        <Table {...extraDocsETS} id="FCR-details-extraEquipmentTransportShipments"
                            hasTotal={true}
                            linkAction={(row: any) => this.props.link(String(`/job-costing/ets/${row!.id}`))} />
                    </Accordion>
                }
                <Accordion title={'voyage'} id="voyages">
                    <Table {...this.props.voyages} id="FCR-details-voyages" />
                </Accordion>
                <Accordion title={'Customer Invoice'} id="customerInvoice">
                    <Table {...customerData} id="FCR-details-customerInvoice"
                        linkAction={(row: any) => {
                            redirectToViewInvoice('origin', row!.internalBillingNo);
                        }} />
                </Accordion>
            </div>
        );
    }
}

export default DocumentDetails;